import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/redpipe/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, hdRacesSettings) {
    await Vue.http.post(`/api/redpipe/settings/byclient/${clientId}`, hdRacesSettings);
    noty.success('Settings saved successfully');
  }
}



// WEBPACK FOOTER //
// ./src/services/redpipe.service.js